export default __webpack_public_path__ + "static/media/alandsbanken.bdcedf8e.png";